// "Customer" card of a charter request: user, seats / passengers, email, phone.
import { Card, Descriptions } from 'antd';

import type { CharterRequestDetail } from '../../api/types';
import { AccountDeletedTag } from '../../components/AccountDeletedTag';

export function CustomerCard({
  r,
}: {
  r: CharterRequestDetail;
}) {
  return (
    <Card title="Customer">
      <Descriptions bordered column={{ xs: 1, sm: 2 }} size="small">
        <Descriptions.Item label="User">
          {r.user ? `${r.user.name}` : '—'} <AccountDeletedTag at={r.user?.accountDeletedAt} />
        </Descriptions.Item>
        <Descriptions.Item label="Seats / passengers">{r.seats} / {r.passengersCount}</Descriptions.Item>
        {/* SHAR-583 — email and phone are two fields, not one "Contact" string. */}
        <Descriptions.Item label="User email">{r.user?.email ?? '—'}</Descriptions.Item>
        <Descriptions.Item label="User's phone number">{r.user?.phone ?? '—'}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
